// Centralized pricing definitions for VelocyTrack
// Preserves consistent pricing across landing page, plans page, and upgrade modals.

export const PRICING_TIERS = [
    {
        id: 'free',
        name: 'Free',
        badge: null,
        priceAmount: 0,
        priceDisplay: '€0',
        period: '/forever',
        subtext: 'Free forever for solo developers',
        desc: 'For individual developers getting started with core sprint tracking and time logging.',
        features: [
            '1 User Seat',
            '1 Project & Manual PAT Auth',
            'Previous, Current & Next Sprint (90-day time log history)',
            'Daily Time Log, Public Holidays & Basic Progress',
            'View-Only Backlog, Hygiene Badges, Pull Requests, Branches & Discussions'
        ],
        ctaText: 'Start Free Sandbox',
        ctaAction: 'demo'
    },
    {
        id: 'pro',
        name: 'Pro Plan',
        badge: 'POPULAR',
        highlight: true,
        priceAmount: null,
        priceDisplay: 'TBA',
        period: '',
        subtext: '100% Free in Open Beta • Pricing Announced at Launch',
        desc: 'For power contractors & engineers needing full project space, PR workflows, and multi-repo radar.',
        features: [
            '1 User Seat',
            '1-Click OAuth & Multi-Project Support',
            'Unlimited Past & Future Sprints (Full history + CSV/Excel Export)',
            'Personal Sprint Capacity Gauge (Auto-prorated for Holidays & PTO)',
            'Full Inline Editing, Next-Sprint Rollover & External AzDO Log Sync',
            '1-Click Hygiene Fixes (state/hour mismatches & post-merge WI close)',
            'Vote, Edit Reviewers, Status Actions & 1-Click Post-Merge WI Close',
            'Direct Inline Replies, Thread Status Resolution & All-Time Search',
            '1-Click Stale/Merged Branch Cleanup & Ahead/Behind Tracking',
            'Personal Behind-Hours, Daily & Weekly Email Digests'
        ],
        ctaText: 'Claim Free Beta Access',
        ctaAction: 'waitlist'
    },
    {
        id: 'team',
        name: 'Team',
        badge: 'COMING NEXT',
        highlight: false,
        priceAmount: null,
        priceDisplay: 'Coming Next',
        period: '',
        subtext: 'Pricing TBA • Announced at Launch',
        desc: 'For engineering squads needing shared capacity rollups, velocity analytics, and cross-team collaboration.',
        features: [
            'Unlimited Team Spaces (Scalable 5-seat squad batches)',
            'Shared Team Project Setup (members inherit project & repo mapping)',
            'Squad Sprint Burn-Down & Deliverable Velocity Pacing',
            'Squad Capacity vs. Workload & PTO Assignment Conflict Alerts',
            'Squad Workload Balance & Unestimated Task Alerts',
            'Squad Blocker Radar & Silent Bottleneck Detection (>4d stuck tasks)',
            'Reviewer Out-of-Office (PTO) Conflict Alerts & Shared Repo PRs',
            'Shared Squad Discussion & Multi-Repo Branch Hygiene Scope',
            '1-Click Manager Nudges & Squad Compliance Alerts'
        ],
        ctaText: 'Get Launch Updates',
        ctaAction: 'launch'
    }
];

export const BETA_GUARANTEE = {
    badge: 'EARLY-BIRD LAUNCH PROMOTION',
    headline: '100% Free During Beta — 50% Off Your First Year',
    description: 'All beta members get full Pro tier capabilities unlocked 100% free during the open beta. When we officially launch, the early-bird offer extends to all beta members and anyone who signs up during the first month after official release: 50% off for the entire first year.'
};
